import DataTable from 'react-data-table-component'
import strings from '../../res/strings'
import styles from './tableStyles'

const UsersTable = (props) => {
    return (
        <DataTable
            className='font-montserrat'
            customStyles={styles}
            columns={props.columns}
            data={props.data}
            conditionalRowStyles={props.conditionalRowStyles}
            highlightOnHover
            pagination
            paginationRowsPerPageOptions={[10, 15]}
            paginationComponentOptions={{ rowsPerPageText: strings.linesPerPage, rangeSeparatorText: strings.of }}
            noDataComponent={<p className='font-montserrat'>{strings.noUsersForSearch}</p>}
        />
    )
}

export default UsersTable